import { render, staticRenderFns } from "./UPSCode.vue?vue&type=template&id=2594f5e7&scoped=true"
import script from "./UPSCode.vue?vue&type=script&lang=js"
export * from "./UPSCode.vue?vue&type=script&lang=js"
import style0 from "./UPSCode.vue?vue&type=style&index=0&id=2594f5e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594f5e7",
  null
  
)

export default component.exports